<template>
  <section
    v-if="filteredCities.length > 0"
    class="home-top-destinations-section py-10 py-sm-16"
  >
    <v-container>
      <div class="section-header mb-10 mb-md-16">
        <h2 class="section-title text-center mb-2">
          {{ $t("most_popular_destinations") }}
        </h2>
        <div class="section-accent mx-auto mb-4"></div>
      </div>
      <v-row class="justify-center mx-0 mx-md-16 home-top-destinations-row">
        <v-col
          v-for="item in filteredCities"
          :key="item.id"
          cols="12"
          sm="6"
          md="4"
          class="d-flex"
        >
          <home-top-destinations-item :item="item" class="flex-grow-1" />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import {
  HOME_TOP_DESTINATIONS_TITLE,
  HOME_TOP_DESTINATIONS_BUTTON_TEXT,
} from "@/consts/CMS";
import HomeTopDestinationsItem from "@/components/home/home-top-destinations-item.vue";

export default {
  name: "home-top-destinations",
  components: { HomeTopDestinationsItem },
  props: {
    cities: {
      type: Array,
    },
  },
  data: () => ({
    HOME_TOP_DESTINATIONS_TITLE,
    HOME_TOP_DESTINATIONS_BUTTON_TEXT,
  }),
  computed: {
    filteredCities() {
      return this.cities.filter((city) => city.image);
    },
  },
};
</script>

<style scoped>
.home-top-destinations-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 32px;
  box-shadow: 0 8px 32px rgba(60, 60, 60, 0.08);
}
.section-header {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}
.section-title {
  font-family: "Fraunces", serif;
  font-size: 2.2rem;
  font-weight: 700;
  letter-spacing: -0.5px;
}
.section-accent {
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #1976d2 0%, #42a5f5 100%);
  border-radius: 2px;
}
.home-top-destinations-row {
  row-gap: 32px;
  column-gap: 0;
}
.home-top-destinations-btn {
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 24px;
  background: linear-gradient(90deg, #1976d2 0%, #42a5f5 100%);
  color: #fff;
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.12);
  transition: box-shadow 0.2s, transform 0.2s;
}
.home-top-destinations-btn:hover {
  box-shadow: 0 8px 32px rgba(25, 118, 210, 0.18);
  transform: translateY(-2px) scale(1.03);
}
</style>
